// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eP476","text":"styles_text__yO5K0","success":"styles_success__3c-y5","button":"styles_button__bSZ0x","error":"styles_error__ktQqN"};